import { AccountMovementsViewModel } from "../accounting/models/accounting-movement.model";

export class InvestmentModel {
  uid: string;
  type: string; //Capital o explotación
  provider: string;  //Nombre proveedor, puede ser un contacto del usuario
  elementDescription: string; ////Descripción del elemento (coche, nevera, ordenador...)
  accountActivity: string; //Actividad de inversion, buscar por type = "inversion" en BBDD
  dateBuy: Date; //Fecha de compra
  dateStartWorking: Date; //Fecha de puesta en funcionamiento
  lifetime: string; //Vida útil (años)
  totalWithoutTax: number; //Importe sin impuestos
  paided: Date; //Fecha de pago
  residualValue: number; //Valor residual
  typeInvestment: string; //Tipo de inversión, tablas, progresiva o degresiva
  maximumLinealCoeficient: number; //Coeficiente lineal maximo
  maximumPeriod: number; //Periodo máximo años
  activityUid: string;
  fiscalYear: number;
  activity: string;

  pending: number;
  acumulated: number;
  image: any;
  pdf: any;
  fileUid: string;

  typePay: string;
  typePayBankAccount: string;

  total: string;

  taxes: Array<InvestmentTaxModel>;

  contactsUid: string;

  //Importación cuentas contables
  manualMovement: AccountMovementsViewModel;

  constructor() {
    this.totalWithoutTax = 0;
    this.pending = 0;
    this.acumulated = 0;
    this.taxes = new Array<InvestmentTaxModel>();
  }
}


export class InvestmentTaxModel {
  id: number;
  uid: string;
  taxId: number;
  taxImport: number;
  type: string;
  name: string;

  constructor() {
  }
}

export class InvestmentsDepositsModel {
  uid: number; // Este es el id, se pone este nombre pero solo por que la tabla esta trabajando con uid
  investmentsUid: string;
  paymentCardsUid: string;
  bankAccountsUid: string;
  amount: number;
  depositDate: Date;
  typePay: string;
  commissions: number;
  bankAccountInfo: string;
  efectivoId: string;
  partnersId: number;
  polizaCreditoId: string;

  constructor() {
  }
}

